import { Outlet } from "react-router-dom";

import NavMenu from "~/common/components/ui/NavMenu";
import { useGetToolsLayoutMenuOptions } from "~/providers/hooks";
import { useUiStore } from "../stores";

export const ToolsLayout = () => {
  const { setSideBarOpen } = useUiStore();

  const { menuOptions } = useGetToolsLayoutMenuOptions();

  return (
    <div className="flex h-screen-calculated w-full flex-col gap-6 text-sm md:gap-8">
      <NavMenu
        title="Admin tools"
        menuOptions={menuOptions}
        handleOpenSideBar={() => setSideBarOpen(true)}
      />
      <Outlet />
    </div>
  );
};
